import React, {Component} from 'react';
import './AddNewProjectButton.css';
import Inputs from '../../../shared/FormComponents/Inputs';
import _ from 'lodash';

class AddNewProject extends Component {

  constructor(props) {
    super(props);
    this.defaultParams = {};
    this.state = {
        projectadded: false,
        addProjectData: false,
        formValid: false,
        createProject: {
            name : '',
        },
        inputStates: {
            name: false,
        }
    };
  }


elementInfiniteLoad() {
    return (
        <div className='col-sm-12'>
            <div className='spinner3'>
            <div className='rect1'/>
            <div className='rect2'/>
            <div className='rect3'/>
            <div className='rect4'/>
            <div className='rect5'/>
            </div>
        </div>
    );
}

render() {
    return (
        <div>
            <div className='btn empty-btn default' onClick={() => this.props.openModal()}> <i className="fa fa-plus" aria-hidden="true"></i>
            Add Project </div>
        </div>



    )
  }
}

export default (AddNewProject);



// WEBPACK FOOTER //
// ./src/components/Toolkit/AddNewProjectButton/AddNewProjectButton.jsx